












import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import i18n from '@/plugins/i18n';

@Component
export default class DeleteConfirmation extends Vue {
  @Prop({ type: Boolean, default: true }) private readonly visible!: boolean;
  @Prop({ type: Boolean, default: true }) private readonly allowedToDelete!: boolean;
  @Prop({ required: true, type: Function }) private readonly action!: () => Promise<void>;

  @Prop({
    type: String,
    default: i18n.t('common.dialog.action.delete').toString()
  })
  private readonly tooltipText!: string;

  @Prop({
    type: String,
    default: i18n.t('common.dialog.confirmation.save').toString()
  })
  private readonly confirmationText!: string;

  @Prop({
    type: String,
    default: 'mdi-delete'
  })
  private readonly icon!: string;

  @Prop({
    type: Boolean,
    default: false
  })
  private readonly iconSmall!: string;

  private async doAction(): Promise<boolean> {
    this.$emit('opened');

    const confirmed: boolean = await this.$confirm(this.confirmationText) || false;

    if (confirmed) {
      await this.action();
      return true;
    }

    return false;
  }
}
